import { IGlobalState } from '../../../Root/store/appReducer'
import { Role } from '../../../services/api.types'

export const getCompanyUsersList = (state: IGlobalState) =>
  state.userManagement.companyUsers.filter((user) => user.role === Role.USER)
export const getCompanyUsersLoading = (state: IGlobalState) => state.userManagement.usersLoading
export const getCompanySignUpCodes = (state: IGlobalState) => state.userManagement.signUpCodes
